<template>
    <div class="container is-max-widescreen has-bg-white py-5">
        <Header/>
        <div class="columns">
            <div class="settings-section column has-background-white rounded-2 column p-0 is-3">
                <aside class="menu pb-5">
                    <p class="title p-3 mb-3 pt-6 ml-3">
                        {{$t('settings')}}
                    </p>

                    <ul class="menu-list">
                        <router-link to="/brandSettings">
                            <li>
                                <a>
                                    {{$t('brand_settings')}} 
                                </a>
                            </li>
                        </router-link>
                        <router-link to="/vendorSettings">
                            <li>
                                <a>
                                    {{$t('vendor_settings')}} 
                                </a>
                            </li>
                        </router-link>
                        <router-link to="/languagePreference">
                            <li>
                                <a>
                                    {{$t('lang_preference')}} 
                                </a>
                            </li>
                        </router-link>
                    </ul>

                </aside>
            </div>
            <div class="main-section column has-background-white rounded-2 column pt-6 pl-5 is-9">

                <h1 class="title is-3">
                    {{$t('lang_preference')}}
                </h1>
                

                <h1 class="title is-6 pt-5 mb-2 langInterface">
                    {{$t('lang_interface')}}
                </h1>

                
                <b-dropdown expanded aria-role="list" class="has-text-left w-100 drop-menu" v-model="$i18n.locale">
                    <template #trigger>
                        <a
                            class="dropdown"
                            role="button">
                            {{$t('lang_'+$i18n.locale)}}
                            <b-icon class="menu-down-icon" icon="menu-down"></b-icon>
                        </a>
                    </template>

                    <b-dropdown-item v-for="lang in langs" :key="lang.value" :value="lang.value" @click="changeLang(lang.value)">
                        {{lang.label}}
                    </b-dropdown-item>

                </b-dropdown>
                

            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import Header from './Header'
import { NotificationProgrammatic as Notification } from 'buefy'

export default {
    name:'Home',
    data() {
        return {
            logoUrl: "/static/images/Logo.svg",
            langs : [{"value":"tr","label":this.$t('lang_tr')},{"value":"en","label":this.$t('lang_en')}],
            name:''
        }
    },
    methods: {
        changeLang(val){
            const form = {}
            form.language = val
            this.setLanguage(form).then((response) => {
                console.log('--setLanguage success response')
                console.log(response)
                if(response.status.code == '0'){
                    localStorage.setItem('lang',val)
                    this.$moment.locale(val)
                    Notification.open({
                            message: this.$t(response.status.name),
                            type: 'is-success',
                            duration:5000
                    })
                }
                console.log("this.data")
                console.log(this.data)
            }).catch(e => {
                console.log('--setLanguage Error')
                console.log(e)
            })
        },
        ...mapActions(['setLanguage']),
    },
    components: {
        Header
    },
}
</script>

<style scoped>
    .drop-menu{
        border: 2px solid #0B5FFF;
        position: relative;
    }
    .dropdown{
        position: relative;
        font-weight: 600;
        color: #000;
    }
    .dropdown .menu-down-icon{
        position: absolute;
        right: 2rem;
        bottom: 8px;
        transform: scale(1.5);
        color: rgb(185, 185, 185);
    }
    .dropdown, .drop-item{
        margin: 0;
        padding: 0.4rem;
        width: 300px;
        border-radius: 8px;
    }
    .settings-section{
        height: 100%;
        margin-right: 2rem;
    }
    .main-section{
        min-height: 35vh;
    }
    @media(max-width: 800px){
        .settings-section{
            margin-right: 0;
            margin-bottom: 2rem;
        }
    }

    @media(max-width: 350px){
        .drop-menu{
            width: 100%;
        }

        .dropdown .menu-down-icon{
            right: 4rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/LanguagePreference.vue